import { Link } from 'react-router-dom';
import { Run, RunStatus } from '../types';

interface RunCardProps {
  run: Run;
  className?: string;
}

export const RunCard: React.FC<RunCardProps> = ({ run, className = '' }) => {
  const getStatusColor = (status: RunStatus) => {
    switch (status) {
      case RunStatus.Open:
      case RunStatus.Collecting:
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case RunStatus.Ordered:
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case RunStatus.PickedUp:
        return 'bg-green-100 text-green-800 border-green-200';
      case RunStatus.Completed:
        return 'bg-gray-100 text-gray-800 border-gray-200';
      case RunStatus.Cancelled:
        return 'bg-red-100 text-red-800 border-red-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getTypeIcon = (description?: string) => {
    const desc = description?.toLowerCase() || '';
    if (desc.includes('coffee')) return '☕';
    if (desc.includes('lunch') || desc.includes('food')) return '🍽️';
    if (desc.includes('drinks') || desc.includes('beverage')) return '🥤';
    return '📦';
  };

  const formatPickupTime = (pickupTime?: string) => {
    if (!pickupTime) return 'TBD';
    return new Date(pickupTime).toLocaleString('en-AU', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <Link
      to={`/run/${run.id}`}
      className={`block bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow duration-200 ${className}`}
    >
      <div className="p-6">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center space-x-2">
            <span className="text-2xl">{getTypeIcon(run.description)}</span>
            <h3 className="text-lg font-semibold text-gray-900 truncate">
              {run.title}
            </h3>
          </div>
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium border ${getStatusColor(
              run.status
            )}`}
          >
            {run.status}
          </span>
        </div>

        {run.description && (
          <p className="text-sm text-gray-600 mb-3 line-clamp-2">
            {run.description}
          </p>
        )}

        <div className="space-y-2 text-sm text-gray-600">
          <div className="flex items-center justify-between">
            <span>📍 Pickup:</span>
            <span className="font-medium">
              {formatPickupTime(run.pickupTime)}
            </span>
          </div>

          {run.pickupLocation && (
            <div className="flex items-center justify-between">
              <span>� Location:</span>
              <span className="font-medium truncate">{run.pickupLocation}</span>
            </div>
          )}

          <div className="flex items-center justify-between">
            <span>�👥 Orders:</span>
            <span className="font-medium">{run.orderCount}</span>
          </div>

          <div className="flex items-center justify-between">
            <span>💰 Total:</span>
            <span className="font-medium">${run.totalAmount.toFixed(2)}</span>
          </div>

          <div className="flex items-center justify-between">
            <span>👤 Organizer:</span>
            <span className="font-medium truncate">{run.createdBy}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default RunCard;
